import { metrics } from '@atlassian/browser-metrics';
import { APP_IDENTIFIER } from '../index';

export const X2C_SCREENS = {
	SELECT_PRODUCT: 'projectCreateImporterSelectProduct',
	SELECT_SOURCE_SCREEN: 'projectCreateImporterSelectSource',
	UPLOAD_CSV: 'projectCreateImporterUploadCSV',
	MAPPING: 'projectCreateImporterMapping',
	SETUP_PROJECT: 'projectCreateImporterSetupProject',
	IMPORT_IN_PROGRESS: 'projectCreateImporterImportInProgress',
	SELECT_THIRD_PARTY_ENTITY_SCREEN: 'projectCreateImporterSelectThirdPartyEntity',
	USER_MAPPING: 'projectCreateImporterUserMapping',
	THIRD_PARTY_REVIEW_SCREEN: 'projectCreateImporterThirdPartyReview',
	REVIEW_SCREEN_STANDARD: 'projectCreateImporterReviewScreenStandard',
} as const;

export type X2C_SCREENS = (typeof X2C_SCREENS)[keyof typeof X2C_SCREENS];

export const EXPERIENCES = {
	UPLOAD_CSV: 'projectCreateImporterUploadCSV',
	READ_CSV: 'projectCreateImporterReadCSV',
	READ_CSV_METADATA: 'projectCreateImporterReadCSVMetadata',
	THIRD_PARTY_OAUTH: 'projectCreateImporterThirdPartyOAuth',
	THIRD_PARTY_POST_ACCESS_TOKEN: 'projectCreateImporterThirdPartyPostToken',
	THIRD_PARTY_POST_ACCESS_TOKEN_STATUS: 'projectCreateImporterThirdPartyPostTokenStatus',
	THIRD_PARTY_GET_SITE_NAME: 'projectCreateImporterThirdPartyGetSiteName',
	THIRD_PARTY_WORKSPACES: 'projectCreateImporterFetchThirdPartyWorkspaces',
	THIRD_PARTY_ENTITIES: 'projectCreateImporterFetchThirdPartyEntities',
	THIRD_PARTY_ENTITIES_PAGE: 'projectCreateImporterFetchThirdPartyEntitiesPage',
	SEARCH_THIRD_PARTY_ENTITIES: 'projectCreateImporterSearchThirdPartyEntities',
	THIRD_PARTY_FOLDERS: 'projectCreateImporterFetchThirdPartyFolders',
	THIRD_PARTY_FIELD_CONFIG: 'projectCreateImporterFetchThirdPartyFieldConfig',
	THIRD_PARTY_ENTITY_STATS: 'projectCreateImporterFetchThirdPartyEntityStats',
	THIRD_PARTY_MULTI_ENTITY_STATS: 'projectCreateImporterFetchThirdPartyMultiEntityStats',
	THIRD_PARTY_MULTI_ENTITY_STATUSES: 'projectCreateImporterFetchThirdPartyMultiEntityStatuses',
	THIRD_PARTY_MEMBERS: 'projectCreateImporterFetchThirdPartyMembers',
	VALIDATE: 'projectCreateImporterValidateMapping',
	START_IMPORT: 'projectCreateImporterStartImport',
	START_THIRD_PARTY_IMPORT: 'projectCreateImporterStartThirdPartyImport',
	IMPORT_PART_1: 'projectCreateImporterImportPart1',
	THIRD_PARTY_SPACES: 'projectCreateImporterFetchThirdPartySpaces',
	IMPORTER_SOURCE: 'projectCreateImporterImporterSource',
} as const;

export type EXPERIENCES = (typeof EXPERIENCES)[keyof typeof EXPERIENCES];

const UPLOAD_CSV_INTERACTION_METRIC_KEY = `${APP_IDENTIFIER}.upload-csv`;
export const uploadInteractionMetric = metrics.interaction({
	key: UPLOAD_CSV_INTERACTION_METRIC_KEY,
	histogram: {
		result: '200_500_1000_2000_3000_4000_5000_10000',
		response: '200_500_1000_2000_3000_4000_5000_10000',
	},
});

const READ_CSV_INTERACTION_METRIC_KEY = `${APP_IDENTIFIER}.read-csv`;
export const readCSVInteractionMetric = metrics.interaction({
	key: READ_CSV_INTERACTION_METRIC_KEY,
	histogram: {
		result: '200_500_1000_2000_3000_4000_5000_10000',
		response: '200_500_1000_2000_3000_4000_5000_10000',
	},
});

const READ_CSV_METADATA_INTERACTION_METRIC_KEY = `${APP_IDENTIFIER}.read-csv-metadata`;
export const readCSVMetadataInteractionMetric = metrics.interaction({
	key: READ_CSV_METADATA_INTERACTION_METRIC_KEY,
	histogram: {
		result: '200_500_1000_2000_3000_4000_5000_10000',
		response: '200_500_1000_2000_3000_4000_5000_10000',
	},
});

const THIRD_PARTY_POST_ACCESS_TOKEN_METRIC_KEY = `${APP_IDENTIFIER}.third-party-post-access-token`;
export const thirdPartyPostAccessTokenMetric = metrics.interaction({
	key: THIRD_PARTY_POST_ACCESS_TOKEN_METRIC_KEY,
	histogram: {
		result: '200_500_1000_2000_3000_4000_5000_10000',
		response: '200_500_1000_2000_3000_4000_5000_10000',
	},
});

const THIRD_PARTY_GET_SITE_NAME_METRIC_KEY = `${APP_IDENTIFIER}.third-party-site-name`;
export const thirdPartySiteNameMetric = metrics.interaction({
	key: THIRD_PARTY_GET_SITE_NAME_METRIC_KEY,
	histogram: {
		result: '200_500_1000_2000_3000_4000_5000_10000',
		response: '200_500_1000_2000_3000_4000_5000_10000',
	},
});

const THIRD_PARTY_ACCESS_TOKEN_STATUS_METRIC_KEY = `${APP_IDENTIFIER}.third-party-access-token-status`;
export const thirdPartyAccessTokenStatusMetric = metrics.interaction({
	key: THIRD_PARTY_ACCESS_TOKEN_STATUS_METRIC_KEY,
	histogram: {
		result: '200_500_1000_2000_3000_4000_5000_10000',
		response: '200_500_1000_2000_3000_4000_5000_10000',
	},
});

const THIRD_PARTY_WORKSPACES_INTERACTION_METRIC_KEY = `${APP_IDENTIFIER}.third-party-workspaces`;
export const thirdPartyWorkspacesInteractionMetric = metrics.interaction({
	key: THIRD_PARTY_WORKSPACES_INTERACTION_METRIC_KEY,
	histogram: {
		result: '200_500_1000_2000_3000_4000_5000_10000',
		response: '200_500_1000_2000_3000_4000_5000_10000',
	},
});

const THIRD_PARTY_ENTITIES_INTERACTION_METRIC_KEY = `${APP_IDENTIFIER}.third-party-entities`;
export const thirdPartyEntitiesInteractionMetric = metrics.interaction({
	key: THIRD_PARTY_ENTITIES_INTERACTION_METRIC_KEY,
	histogram: {
		result: '200_500_1000_2000_3000_4000_5000_10000',
		response: '200_500_1000_2000_3000_4000_5000_10000',
	},
});

const THIRD_PARTY_ENTITIES_PAGE_INTERACTION_METRIC_KEY = `${APP_IDENTIFIER}.third-party-entities-page`;
export const thirdPartyEntitiesPageInteractionMetric = metrics.interaction({
	key: THIRD_PARTY_ENTITIES_PAGE_INTERACTION_METRIC_KEY,
	histogram: {
		result: '200_500_1000_2000_3000_4000_5000_10000',
		response: '200_500_1000_2000_3000_4000_5000_10000',
	},
});

const SEARCH_THIRD_PARTY_ENTITIES_INTERACTION_METRIC_KEY = `${APP_IDENTIFIER}.search-third-party-entities`;
export const searchThirdPartyEntitiesInteractionMetric = metrics.interaction({
	key: SEARCH_THIRD_PARTY_ENTITIES_INTERACTION_METRIC_KEY,
	histogram: {
		result: '200_500_1000_2000_3000_4000_5000_10000',
		response: '200_500_1000_2000_3000_4000_5000_10000',
	},
});

const THIRD_PARTY_FOLDERS_INTERACTION_METRIC_KEY = `${APP_IDENTIFIER}.third-party-folders`;
export const thirdPartyFoldersInteractionMetric = metrics.interaction({
	key: THIRD_PARTY_FOLDERS_INTERACTION_METRIC_KEY,
	histogram: {
		result: '200_500_1000_2000_3000_4000_5000_10000',
		response: '200_500_1000_2000_3000_4000_5000_10000',
	},
});

const THIRD_PARTY_MEMBERS_INTERACTION_METRIC_KEY = `${APP_IDENTIFIER}.third-party-members`;
export const thirdPartyMembersInteractionMetric = metrics.interaction({
	key: THIRD_PARTY_MEMBERS_INTERACTION_METRIC_KEY,
	histogram: {
		result: '200_500_1000_2000_3000_4000_5000_10000',
		response: '200_500_1000_2000_3000_4000_5000_10000',
	},
});

const THIRD_PARTY_ENTITY_STATS_INTERACTION_METRIC_KEY = `${APP_IDENTIFIER}.third-party-entity-stats`;
export const thirdPartyEntityStatsInteractionMetric = metrics.interaction({
	key: THIRD_PARTY_ENTITY_STATS_INTERACTION_METRIC_KEY,
	histogram: {
		result: '200_500_1000_2000_3000_4000_5000_10000',
		response: '200_500_1000_2000_3000_4000_5000_10000',
	},
});

const THIRD_PARTY_MULTI_ENTITY_STATS_INTERACTION_METRIC_KEY = `${APP_IDENTIFIER}.third-party-multi-entity-stats`;
export const thirdPartyMultiEntityStatsInteractionMetric = metrics.interaction({
	key: THIRD_PARTY_MULTI_ENTITY_STATS_INTERACTION_METRIC_KEY,
	histogram: {
		result: '200_500_1000_2000_3000_4000_5000_10000',
		response: '200_500_1000_2000_3000_4000_5000_10000',
	},
});

const THIRD_PARTY_FIELD_CONFIG_INTERACTION_METRIC_KEY = `${APP_IDENTIFIER}.third-party-field-config`;
export const thirdPartyFieldConfigInteractionMetric = metrics.interaction({
	key: THIRD_PARTY_FIELD_CONFIG_INTERACTION_METRIC_KEY,
	histogram: {
		result: '200_500_1000_2000_3000_4000_5000_10000',
		response: '200_500_1000_2000_3000_4000_5000_10000',
	},
});

const THIRD_PARTY_SPACES_INTERACTION_METRIC_KEY = `${APP_IDENTIFIER}.third-party-spaces`;
export const thirdPartySpacesInteractionMetric = metrics.interaction({
	key: THIRD_PARTY_SPACES_INTERACTION_METRIC_KEY,
	histogram: {
		result: '200_500_1000_2000_3000_4000_5000_10000',
		response: '200_500_1000_2000_3000_4000_5000_10000',
	},
});

const THIRD_PARTY_MULTI_ENTITY_STATUSES_INTERACTION_METRIC_KEY = `${APP_IDENTIFIER}.third-party-multi-entity-statuses`;
export const thirdPartyMultiEntityStatusesInteractionMetric = metrics.interaction({
	key: THIRD_PARTY_MULTI_ENTITY_STATUSES_INTERACTION_METRIC_KEY,
	histogram: {
		result: '200_500_1000_2000_3000_4000_5000_10000',
		response: '200_500_1000_2000_3000_4000_5000_10000',
	},
});

const VALIDATE_MAPPING_INTERACTION_METRIC_KEY = `${APP_IDENTIFIER}.validate-mapping`;
export const validateMappingInteractionMetric = metrics.interaction({
	key: VALIDATE_MAPPING_INTERACTION_METRIC_KEY,
	histogram: {
		result: '200_500_1000_2000_3000_4000_5000_10000',
		response: '200_500_1000_2000_3000_4000_5000_10000',
	},
});

const START_IMPORT_INTERACTION_METRIC_KEY = `${APP_IDENTIFIER}.start-import`;
export const startImportInteractionMetric = metrics.interaction({
	key: START_IMPORT_INTERACTION_METRIC_KEY,
	histogram: {
		result: '200_500_1000_2000_3000_4000_5000_10000',
		response: '200_500_1000_2000_3000_4000_5000_10000',
	},
});

const START_THIRD_PARTY_IMPORT_INTERACTION_METRIC_KEY = `${APP_IDENTIFIER}.third-party-start-import`;
export const startThirdPartyImportInteractionMetric = metrics.interaction({
	key: START_THIRD_PARTY_IMPORT_INTERACTION_METRIC_KEY,
	histogram: {
		result: '200_500_1000_2000_3000_4000_5000_10000',
		response: '200_500_1000_2000_3000_4000_5000_10000',
	},
});

const IMPORTER_SOURCE_INTERACTION_METRIC_KEY = `${APP_IDENTIFIER}.importer-source`;
export const importerSourceInteractionMetric = metrics.interaction({
	key: IMPORTER_SOURCE_INTERACTION_METRIC_KEY,
	histogram: {
		result: '200_500_1000_2000_3000_4000_5000_10000',
		response: '200_500_1000_2000_3000_4000_5000_10000',
	},
});
